import { selectJobDate } from './job-date.reducer';
import { createSelector } from '@ngrx/store';

export const selectJobDateState = createSelector(
  selectJobDate,
  jobDate => jobDate
);
